import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog, FormErrorModel } from 'Models'
import { QuestionModel } from 'Pages/survey'
import { Callback } from 'Src/types/utilTypes'

export namespace QuestionNS {
	export type ClearQuestion = PayloadAction
	export type SetParams = PayloadAction<RequestParams>
	export type GetOne = PayloadAction<number>
	export type SetOne = PayloadAction<ResponseCatalog<QuestionModel>>
	export type CreateOne = PayloadAction<{
		data: QuestionModel
		callback?: Callback
	}>
	export type UpdateOne = PayloadAction<{
		data: QuestionModel
		callback?: Callback
	}>
	export type DeleteOne = PayloadAction<{
		survey_id: number
		id: number
		callback?: Callback
	}>
	export type SetFromError = PayloadAction<FormErrorModel>
}

export const questionSlice = createSlice({
	name: 'question',
	initialState: {},
	reducers: {
		clearQuestion: (state, action: QuestionNS.ClearQuestion) => {},
		setParams: (state, action: QuestionNS.SetParams) => {},
		getOne: (state, action: QuestionNS.GetOne) => {},
		setOne: (state, action: QuestionNS.SetOne) => {},
		createOne: (state, action: QuestionNS.CreateOne) => {},
		updateOne: (state, action: QuestionNS.UpdateOne) => {},
		deleteOne: (state, action: QuestionNS.DeleteOne) => {},
		setFromError: (state, action: QuestionNS.SetFromError) => {},
	},
})
